<template>
  <div class="confirm-delete" v-if="isVisible">
    <p class="confirm-delete__text">
      Are you sure you want to confirm <b>{{ title }}</b>?
    </p>
    <div class="confirm-delete__buttons">
      <button class="confirm-delete__button confirm-delete__button--cancel button button--border" @click="$emit('cancel')">No, keep.</button>
      <button class="confirm-delete__button confirm-delete__button--confirm button button--border" @click="$emit('confirm')">Yes, delete.</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDelete',

  props: {
    title: {
      type: String,
      default: 'this item'
    },

    isVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.confirm-delete {
  margin-top: 1rem;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem 2rem;
  align-items: center;
  border-radius: 2.25rem;
  background-color: #fff;
}

.confirm-delete__text {
  min-width: 260px;
}

.confirm-delete__buttons {
  display: inline-grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, min-content);
  justify-content: end;
  column-gap: .5rem;
}

.confirm-delete__button {
  white-space: nowrap;
}

.confirm-delete__button--cancel {
  --button-fg: #607D8B;
  --button-fg-active: #455A64;
}

.confirm-delete__button--confirm {
  --button-fg: #F44336;
  --button-fg-active: #D32F2F;
}
</style>
